'use client';

import { useProduct } from '@/entities/product';

import { GalleryBase } from '../GalleryBase';
import { GalleryModal } from '../GalleryModal';

export const ProductGallery = () => {
    const { product } = useProduct();
    const media = product?.media ?? [];
    const productName = product?.name ?? '';

    if (!media.length) return null;

    return (
        <>
            <GalleryBase media={media} productName={productName} />
            <GalleryModal media={media} productName={productName} />
        </>
    );
};
